import { render } from "./IndexDiscussion.vue?vue&type=template&id=bf8f5e30"
import script from "./IndexDiscussion.vue?vue&type=script&lang=js"
export * from "./IndexDiscussion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.27_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__